import React from 'react';
import ReadMoreBtn from "./ReadMoreBtn"

const NewsPreview = ({image, title, isDesktop}) => {
    const url = new URL(window.location.href);
    const fullNewsUrl = new URL(url);
    if (fullNewsUrl.pathname.includes("preview/")) {
        fullNewsUrl.pathname = fullNewsUrl.pathname.replace(/\/(preview|news|preview\/news)\//, "full/");
    }
    else {
        fullNewsUrl.searchParams.set('view', 'full');
    }

    return (
        <a className="card-link" href={fullNewsUrl.toString()} target="_blank">
            <div className="card">
                <div className="content">
                    {isDesktop ? <div className="gradient"></div> : null}
                    <div className="header">
                        <h3>{title}</h3>
                        <ReadMoreBtn/>
                    </div>
                </div>
                <div className="image">
                    <img src={image} alt={title}/>
                </div>
            </div>
        </a>
    );
}

export default NewsPreview;
